import React from "react";
import NavBar from "../components/homePage/navBar";
import InventoryById from "../components/Inventories/InventoryById";

const InventoryByIdPage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <InventoryById />
        </div>
    )
}

export default InventoryByIdPage;